import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Statistics: 'Statistics',
      Common: 'Common',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize',
      fromDate:"fromDate"
    })
  },
  methods: {
    ...mapMutations({
      SETOPTIONS: 'Statistics/SETOPTIONS',
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
      setSearchData_M:"Statistics/setSearchData_M"
    }),
    ...mapActions({
      searchTable_A:"Statistics/searchTable_A",
      downloadStatistics_A:"Statistics/downloadStatistics_A"
    })

  }

}




// WEBPACK FOOTER //
// ./src/pages/PartI/Statistics/components/Mixins.js